import React, { useRef } from "react";

import { Divider, Form, Icon, Input } from "semantic-ui-react";

import HeaderCustom from "./HeaderCustom";

type RegisterCompleteContentBasicProps = {
  data: Record<string, any>;
};

const RegisterCompleteContentBasic: React.FC<RegisterCompleteContentBasicProps> = (props) => {
  const inputRef = useRef<Input>(null);

  const handleCopyClipboard = () => {
    const copyText = inputRef.current;

    copyText?.select();
    document.execCommand("copy");
  };

  return (
    <>
      <HeaderCustom label="ข้อมูลบัญชี" />
      <Form>
        <Form.Group inline>
          <Form.Field width={4}>ชื่อ Official Account</Form.Field>
          <Form.Field width={4}>{props.data.account_name}</Form.Field>
        </Form.Group>
      </Form>
      <Divider style={{ borderTop: "1px solid rgb(238 233 233)" }} />
      <HeaderCustom label="Link สำหรับการใช้งาน" hideDivider />
      <div style={{ alignItems: "baseline", display: "flex", marginTop: "10px" }}>
        <label style={{ fontWeight: "bold", marginRight: "20px" }}>Official Account link</label>
        <div style={{ display: "grid" }}>
          <div>
            <Input
              ref={inputRef}
              className="primary"
              style={{ marginRight: "10px" }}
              value={props.data.account_link}
              readOnly
            />
            <Icon
              className="primary"
              style={{ cursor: "pointer" }}
              name="copy"
              onClick={handleCopyClipboard}
            />
          </div>
          <div style={{ marginTop: "15px" }}>
            ท่านสามารถคัดลอกและส่ง Link นี้ให้กับผู้ป่วยในเครือของท่าน เพื่อเชิญเข้าใช้งาน
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterCompleteContentBasic;
